<template lang="pug">
  div
    b-row
      .col-xl-10
        panel(:title='$t("ui.new") + " " + $helpers.getUplineName($store.getters.accountType-1)')
          searchCopy
</template>

<script>
import searchCopy from "@/components/newAccount/searchCopy";

export default {
  components: {
    searchCopy
  },
  computed: {
    selected: function() {
      return this.$route.query.id == "searchCopy"
    }
  }
}
</script>